import request from '@/utils/request'
// 竞猜活动接口
const url = '/api/guess.Hbrb/'
/**
 * 活动信息
 * @param {array} params 请求参数
 */
export function reqGuessInfo(params) {
  return request({
    url: url + 'info',
    method: 'get',
    params: params
  })
}

/**
 * 活动扩展信息
 * @param {array} params 请求参数
 */
export function reqGuessExtend(params) {
  return request({
    url: url + 'extend',
    method: 'get',
    params: params
  })
}

/**
 * 赛程分组列表
 * @param {array} params 请求参数
 */
export function reqGroups(params) {
  return request({
    url: url + 'groups',
    method: 'get',
    params: params
  })
}

/**
 * 历史赛程分组列表
 * @param {array} params 请求参数
 */
export function reqGroupsHistory(params) {
  return request({
    url: url + 'history',
    method: 'get',
    params: params
  })
}

/**
 * 赛程列表
 * @param {array} params 请求参数
 */
export function reqContest(params) {
  return request({
    url: url + 'contests',
    method: 'get',
    params: params
  })
}

/**
 * 赛程详情
 * @param {array} params 请求参数
 */
export function reqContestInfo(params) {
  return request({
    url: url + 'show',
    method: 'get',
    params: params
  })
}

/**
 * 赛程详情
 * @param {array} params 请求参数
 */
export function reqDopk(params) {
  return request({
    url: url + 'dopk',
    method: 'get',
    params: params
  })
}

/**
 * 用户详情
 * @param {array} params 请求参数
 */
export function reqUserInfo(params) {
  return request({
    url: url + 'userinfo',
    method: 'get',
    params: params
  })
}

/**
 * 我的奖品列表
 * @param {array} params 请求参数
 */
export function reqMyPrize(params) {
  return request({
    url: url + 'myPrizeList',
    method: 'get',
    params: params
  })
}

/**
 * 修改联系方式
 * @param {array} params 请求参数
 */
export function reqEditContect(params) {
  return request({
    url: url + 'editContect',
    method: 'get',
    params: params
  })
}



/**
 * 获取用户id
 * @param {array} params 请求参数
 */
export function reqGetUid(params) {
  return request({
    url: url + 'getUid',
    method: 'get',
    params: params
  })
}

/**
 * 用户登记
 * @param {array} params 请求参数
 */
export function reqIsReg(params) {
  return request({
    url: url + 'isReg',
    method: 'get',
    params: params
  })
}

/**
 * 中奖用户列表（10位）
 * @param {array} params 请求参数
 */
export function reqLuckList(params) {
  return request({
    url: url + 'luckList',
    method: 'get',
    params: params
  })
}

/**
 * 总积分排行
 * @param {array} params 请求参数
 */
export function reqRankScore(params) {
  return request({
    url: url + 'rankScore',
    method: 'get',
    params: params
  })
}

/**
 * 总参与排行
 * @param {array} params 请求参数
 */
export function reqRankAct(params) {
  return request({
    url: url + 'rankAct',
    method: 'get',
    params: params
  })
}

/**
 * 猜对次数排行
 * @param {array} params 请求参数
 */
export function reqRankWin(params) {
  return request({
    url: url + 'rankWin',
    method: 'get',
    params: params
  })
}




/**
 * 增加积分
 * @param {array} params 请求参数
 */
export function reqAddScore(params) {
  return request({
    url: url + 'addScore',
    method: 'get',
    params: params
  })
}


/**
 * 查询用户是否进行指定课程的答题
 * @param {array} params 请求参数
 */
export function reqIsAnswer(params) {
  return request({
    url: url + 'isAnswer',
    method: 'get',
    params: params
  })
}

/**
 * 提交课程答题
 * @param {array} params 请求参数
 */
export function reqSubAnswer(params) {
  return request({
    url: url + 'subAnswer',
    method: 'get',
    params: params
  })
}

